import { render, staticRenderFns } from "./FeedbackVideo.vue?vue&type=template&id=4c591284&scoped=true&"
import script from "./FeedbackVideo.vue?vue&type=script&lang=ts&"
export * from "./FeedbackVideo.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackVideo.vue?vue&type=style&index=0&id=4c591284&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c591284",
  null
  
)

export default component.exports